__turbopack_context__.v({
  "badge-container": "gSqNNW_badge-container",
  "clickable-container": "gSqNNW_clickable-container",
  "content-container": "gSqNNW_content-container",
  "options-container": "gSqNNW_options-container",
  "question-card": "gSqNNW_question-card",
  "question-container": "gSqNNW_question-container",
  "question-heading": "gSqNNW_question-heading",
});
